var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.4 123.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.38 77.14h14v19.8h-14v26.76H51.83V96.94H1.1L0 81.48 51.57 0h24.81zm-51.91 0h27.36V33.47l-1.62 2.81z",
    fill: "#fff"
  })));
}
Svg04.displayName = '04';
export default Svg04;